import { useEffect, useState } from "react";
import { fetchdestination } from "../services/DestinationsDetaillist";
import { API_BASE } from "../api/apiConfig";
import { useParams } from "react-router-dom";

const DestinationsDetaillist = () => {
  const { city } = useParams();
  const [activeTab, setActiveTab] = useState("group");
  const [groupTrips, setGroupTrips] = useState([]);
  const [customTrips, setCustomTrips] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cityData, setCityData] = useState(null);

  useEffect(() => {
  const loadTrips = async () => {
    try {
      const result = await fetchdestination(city);

      if (result?.status) {
        setGroupTrips(result.grouptripsdata || []);
        setCustomTrips(result.customizedtripsdata || []);
      }

      if (result?.status && result.citydata?.length > 0) {
        setCityData(result.citydata[0]);
      }

    } catch (err) {
      console.error("Error fetching trips:", err);
    } finally {
      setLoading(false);
    }
  };

  loadTrips();
}, [city]);

  return (
    <>
      
      <div className="hidden md:block">
      <div className="relative h-64 bg-slate-900">
        <img
          alt={cityData?.city}
          loading="lazy"
          decoding="async"
          data-nimg="fill"
          className="object-cover opacity-60"
          style={{
            position: "absolute",
            height: "100%",
            width: "100%",
            inset: 0,
            color: "transparent"
          }}
          src={
            cityData?.cover_image
              ? `${API_BASE}${cityData.cover_image}`
              : `${API_BASE}default.jpg`
          }
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-transparent" />
        <div className="absolute inset-0 flex items-center">
          <div className="container mx-auto px-6">
            <a
              className="inline-flex items-center text-white/80 hover:text-white mb-4 text-sm"
              href="/"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-arrow-left h-4 w-4 mr-2"
              >
                <path d="m12 19-7-7 7-7" />
                <path d="M19 12H5" />
              </svg>
              Back to Home
            </a>
            <h1 className="text-4xl font-bold text-white mb-2">
              {cityData?.city}
            </h1>
            <p className="text-white/80 text-lg">
              {cityData?.title}
            </p>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-6 py-10">

        {/* Tabs */}
      <div className="flex gap-4 mb-8">
        <button
          onClick={() => setActiveTab("group")}
          className={`inline-flex items-center justify-center rounded-md text-sm font-medium h-10 px-4 py-2 ${
            activeTab === "group"
              ? "text-white bg-teal-600 hover:bg-teal-700"
              : "border bg-background hover:bg-accent"
          }`}
        >
          Group Trips ({groupTrips.length})
        </button>

        <button
          onClick={() => setActiveTab("custom")}
          className={`inline-flex items-center justify-center rounded-md text-sm font-medium h-10 px-4 py-2 ${
            activeTab === "custom"
              ? "text-white bg-teal-600 hover:bg-teal-700"
              : "border bg-background hover:bg-accent"
          }`}
        >
          Customized Trips ({customTrips.length})
        </button>
      </div>

      {/* Content */}
      <div>
        {/* GROUP TRIPS */}
        {activeTab === "group" && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

            {loading ? (
              <p>Loading...</p>
            ) : groupTrips.length > 0 ? (
              groupTrips.map((trip) => (
                <a key={trip.id} href={`/GroupTripsDtl/${trip.id}`}>
                <div className="rounded-lg border bg-card text-card-foreground shadow-sm overflow-hidden hover:shadow-xl transition-shadow">
                  <div className="relative h-52">
                    <img
                      alt={trip.name}
                      loading="lazy"
                      decoding="async"
                      data-nimg="fill"
                      className="object-cover"
                      style={{
                        position: "absolute",
                        height: "100%",
                        width: "100%",
                        inset: 0,
                        color: "transparent"
                      }}
                      src={`${API_BASE}/${trip.images}`}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 absolute top-4 left-4 bg-red-500 text-white">
                      Only {trip.spots} left
                    </div>
                    <div className="absolute bottom-4 left-4 right-4">
                      <h3 className="text-white font-bold text-lg">
                        {trip.name}
                      </h3>
                      <div className="flex items-center gap-1 text-white/80 text-sm mt-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-map-pin h-4 w-4"
                        >
                          <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                          <circle cx={12} cy={10} r={3} />
                        </svg>
                        <span>{trip.city}</span>
                      </div>
                    </div>
                  </div>
                  <div className="p-4">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-4 text-sm text-slate-600">
                        <span className="flex items-center gap-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-clock h-4 w-4"
                          >
                            <circle cx={12} cy={12} r={10} />
                            <polyline points="12 6 12 12 16 14" />
                          </svg>
                          {trip.no_of_days}D/{trip.duration}
                        </span>
                        {/*<span className="flex items-center gap-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-users h-4 w-4"
                          >
                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                            <circle cx={9} cy={7} r={4} />
                            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                          </svg>
                          12-15
                        </span>*/}
                        <span className="flex items-center gap-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-star h-4 w-4 fill-yellow-400 text-yellow-400"
                          >
                            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                          </svg>
                          4.9
                        </span>
                      </div>
                      <div className="text-right">
                        <span className="text-sm text-slate-400 line-through">
                          ₹{trip.difficulties}
                        </span>
                        <p className="text-teal-600 font-bold text-lg">₹{trip.charges}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
              ))
            ) : (
              <p>No group trips found</p>
            )}

          </div>
        )}

        {/* CUSTOM TRIPS */}
        {activeTab === "custom" && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

            {loading ? (
              <p>Loading...</p>
            ) : customTrips.length > 0 ? (
              customTrips.map((trip) => (
                <a key={trip.id} href={`/CustomizedTripsDtl/Domestic/${trip.id}`}>
                <div className="rounded-lg border bg-card text-card-foreground shadow-sm overflow-hidden hover:shadow-xl transition-shadow">
                  <div className="relative h-52">
                    <img
                      alt={trip.name}
                      loading="lazy"
                      decoding="async"
                      data-nimg="fill"
                      className="object-cover"
                      style={{
                        position: "absolute",
                        height: "100%",
                        width: "100%",
                        inset: 0,
                        color: "transparent"
                      }}
                      src={`${API_BASE}/${trip.images}`}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 absolute top-4 left-4 bg-red-500 text-white">
                      Only {trip.spots} left
                    </div>
                    <div className="absolute bottom-4 left-4 right-4">
                      <h3 className="text-white font-bold text-lg">
                        {trip.name}
                      </h3>
                      <div className="flex items-center gap-1 text-white/80 text-sm mt-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-map-pin h-4 w-4"
                        >
                          <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                          <circle cx={12} cy={10} r={3} />
                        </svg>
                        <span>{trip.city}</span>
                      </div>
                    </div>
                  </div>
                  <div className="p-4">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-4 text-sm text-slate-600">
                        <span className="flex items-center gap-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-clock h-4 w-4"
                          >
                            <circle cx={12} cy={12} r={10} />
                            <polyline points="12 6 12 12 16 14" />
                          </svg>
                          {trip.no_of_days}D/{trip.duration}
                        </span>
                        {/*<span className="flex items-center gap-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-users h-4 w-4"
                          >
                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                            <circle cx={9} cy={7} r={4} />
                            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                          </svg>
                          12-15
                        </span>*/}
                        <span className="flex items-center gap-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-star h-4 w-4 fill-yellow-400 text-yellow-400"
                          >
                            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                          </svg>
                          4.9
                        </span>
                      </div>
                      <div className="text-right">
                      {Number(trip.charges) === 0 ? (
                         <p className="text-teal-600 font-bold text-lg">Customised</p>
                          ) : (
                            <>
                        <span className="text-sm text-slate-400 line-through">
                          ₹{trip.difficulties}
                        </span>
                        <p className="text-teal-600 font-bold text-lg">₹{trip.charges}</p>
                      </>
                      )}
                      </div>
                    </div>
                  </div>
                </div>
              </a>
              ))
            ) : (
              <div className="col-span-3 text-center py-16">
                <p className="text-slate-500 text-lg">
                  No customized trips found for Spiti Valley
                </p>
                <a href="/customizedtrips">
                  <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 text-primary-foreground h-10 px-4 py-2 mt-4 bg-teal-600 hover:bg-teal-700">
                    Browse All Customized Trips
                  </button>
                </a>
              </div>
            )}

          </div>
        )}
      </div>
        
        <section className="mt-16">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-2xl font-bold text-slate-900">
                What Travelers Say About Spiti Valley
              </h2>
              <p className="text-slate-600 mt-1">
                Real experiences from our community
              </p>
            </div>
            <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 bg-transparent">
              View All Reviews
            </button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="rounded-lg bg-card text-card-foreground border shadow-md hover:shadow-lg transition-shadow">
              <div className="p-6">
                <div className="flex items-center gap-1 mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                  >
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                  >
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                  >
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                  >
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                  >
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                  </svg>
                </div>
                <p className="text-slate-700 mb-4 leading-relaxed">
                  "One of the best trips I've ever taken! Spiti Valley was
                  absolutely breathtaking and the team made sure everything was
                  perfect."
                </p>
                <div className="flex items-center gap-3 pt-4 border-t">
                  <div className="w-12 h-12 rounded-full overflow-hidden">
                    <img
                      alt="Priya Sharma"
                      loading="lazy"
                      width={48}
                      height={48}
                      decoding="async"
                      data-nimg={1}
                      className="object-cover"
                      style={{ color: "transparent" }}
                      src="/assets/images/coastal-mountain-vista.png"
                    />
                  </div>
                  <div>
                    <h4 className="font-semibold text-slate-900">
                      Priya Sharma
                    </h4>
                    <p className="text-sm text-slate-500">
                      Mumbai | December 2025
                    </p>
                    <p className="text-xs text-teal-600 font-medium">
                      Group Trip - 7 Days
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="rounded-lg bg-card text-card-foreground border shadow-md hover:shadow-lg transition-shadow">
              <div className="p-6">
                <div className="flex items-center gap-1 mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                  >
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                  >
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                  >
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                  >
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                  >
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                  </svg>
                </div>
                <p className="text-slate-700 mb-4 leading-relaxed">
                  "Met amazing people and created lifelong memories. The
                  pre-trip meetup was a great idea - I already knew my travel
                  buddies before we left!"
                </p>
                <div className="flex items-center gap-3 pt-4 border-t">
                  <div className="w-12 h-12 rounded-full overflow-hidden">
                    <img
                      alt="Rahul Mehta"
                      loading="lazy"
                      width={48}
                      height={48}
                      decoding="async"
                      data-nimg={1}
                      className="object-cover"
                      style={{ color: "transparent" }}
                      src="/assets/images/solo-mountain-vista.png"
                    />
                  </div>
                  <div>
                    <h4 className="font-semibold text-slate-900">
                      Rahul Mehta
                    </h4>
                    <p className="text-sm text-slate-500">
                      Delhi | November 2025
                    </p>
                    <p className="text-xs text-teal-600 font-medium">
                      Group Trip - 5 Days
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="rounded-lg bg-card text-card-foreground border shadow-md hover:shadow-lg transition-shadow">
              <div className="p-6">
                <div className="flex items-center gap-1 mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                  >
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                  >
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                  >
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                  >
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                  </svg>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                  >
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                  </svg>
                </div>
                <p className="text-slate-700 mb-4 leading-relaxed">
                  "Perfectly organized customized trip for our family. Every
                  detail was taken care of. Highly recommend!"
                </p>
                <div className="flex items-center gap-3 pt-4 border-t">
                  <div className="w-12 h-12 rounded-full overflow-hidden">
                    <img
                      alt="Ananya Krishnan"
                      loading="lazy"
                      width={48}
                      height={48}
                      decoding="async"
                      data-nimg={1}
                      className="object-cover"
                      style={{ color: "transparent" }}
                      src="/assets/images/manhattan-twilight.png"
                    />
                  </div>
                  <div>
                    <h4 className="font-semibold text-slate-900">
                      Ananya Krishnan
                    </h4>
                    <p className="text-sm text-slate-500">
                      Bangalore | October 2025
                    </p>
                    <p className="text-xs text-teal-600 font-medium">
                      Customized Trip - 6 Days
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="mt-16 bg-gradient-to-r from-slate-50 to-slate-100 rounded-2xl p-8">
          <h2 className="text-2xl font-bold text-slate-900 text-center mb-8">
            Why Book With Connecting Traveller
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="h-14 w-14 rounded-2xl bg-gradient-to-br from-teal-500 to-cyan-500 flex items-center justify-center mx-auto mb-4 shadow-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-shield h-7 w-7 text-white"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
                </svg>
              </div>
              <h3 className="font-bold text-slate-900 mb-2">
                100% Safe Travel
              </h3>
              <p className="text-sm text-slate-600">
                All trips are verified and payments are secure
              </p>
            </div>
            <div className="text-center">
              <div className="h-14 w-14 rounded-2xl bg-gradient-to-br from-teal-500 to-cyan-500 flex items-center justify-center mx-auto mb-4 shadow-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-headphones h-7 w-7 text-white"
                >
                  <path d="M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3" />
                </svg>
              </div>
              <h3 className="font-bold text-slate-900 mb-2">24/7 Support</h3>
              <p className="text-sm text-slate-600">
                Our team is always available to help you
              </p>
            </div>
            <div className="text-center">
              <div className="h-14 w-14 rounded-2xl bg-gradient-to-br from-teal-500 to-cyan-500 flex items-center justify-center mx-auto mb-4 shadow-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-award h-7 w-7 text-white"
                >
                  <circle cx={12} cy={8} r={6} />
                  <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11" />
                </svg>
              </div>
              <h3 className="font-bold text-slate-900 mb-2">
                Best Price Guarantee
              </h3>
              <p className="text-sm text-slate-600">
                Find a lower price? We'll match it
              </p>
            </div>
            <div className="text-center">
              <div className="h-14 w-14 rounded-2xl bg-gradient-to-br from-teal-500 to-cyan-500 flex items-center justify-center mx-auto mb-4 shadow-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-message-circle h-7 w-7 text-white"
                >
                  <path d="m3 21 1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z" />
                </svg>
              </div>
              <h3 className="font-bold text-slate-900 mb-2">
                Pre-Trip Meetups
              </h3>
              <p className="text-sm text-slate-600">
                Meet your travel buddies before the trip
              </p>
            </div>
          </div>
        </section>
        <section className="mt-16">
          <h2 className="text-2xl font-bold text-slate-900 mb-2">
            Frequently Asked Questions
          </h2>
          <p className="text-slate-600 mb-8">
            Everything you need to know about trips to Spiti Valley
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <details className="group bg-white border rounded-xl shadow-sm hover:shadow-md transition-shadow">
              <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                <span className="font-medium text-slate-900 pr-4">
                  What is the best time to visit Spiti Valley?
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-chevron-down h-5 w-5 text-slate-500 group-open:rotate-180 transition-transform flex-shrink-0"
                >
                  <path d="m6 9 6 6 6-6" />
                </svg>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-slate-600">
                  The best time to visit Spiti Valley depends on your
                  preferences. Most travelers prefer visiting during pleasant
                  weather conditions which allows for comfortable outdoor
                  activities and sightseeing.
                </p>
              </div>
            </details>
            <details className="group bg-white border rounded-xl shadow-sm hover:shadow-md transition-shadow">
              <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                <span className="font-medium text-slate-900 pr-4">
                  How do I book a trip?
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-chevron-down h-5 w-5 text-slate-500 group-open:rotate-180 transition-transform flex-shrink-0"
                >
                  <path d="m6 9 6 6 6-6" />
                </svg>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-slate-600">
                  Simply select your preferred trip, choose your dates, and
                  complete the booking. Our team will contact you within 24
                  hours to confirm details and answer any questions.
                </p>
              </div>
            </details>
            <details className="group bg-white border rounded-xl shadow-sm hover:shadow-md transition-shadow">
              <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                <span className="font-medium text-slate-900 pr-4">
                  Can I customize a group trip?
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-chevron-down h-5 w-5 text-slate-500 group-open:rotate-180 transition-transform flex-shrink-0"
                >
                  <path d="m6 9 6 6 6-6" />
                </svg>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-slate-600">
                  Yes! We offer flexible customization options for group trips.
                  Contact our team to discuss your specific requirements,
                  preferences, and budget.
                </p>
              </div>
            </details>
            <details className="group bg-white border rounded-xl shadow-sm hover:shadow-md transition-shadow">
              <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                <span className="font-medium text-slate-900 pr-4">
                  What's included in the trip price?
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-chevron-down h-5 w-5 text-slate-500 group-open:rotate-180 transition-transform flex-shrink-0"
                >
                  <path d="m6 9 6 6 6-6" />
                </svg>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-slate-600">
                  Most trips include accommodation, meals as specified, local
                  transportation, activities, and a dedicated trip coordinator.
                  Check individual trip pages for specific inclusions.
                </p>
              </div>
            </details>
            <details className="group bg-white border rounded-xl shadow-sm hover:shadow-md transition-shadow">
              <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                <span className="font-medium text-slate-900 pr-4">
                  Are solo travelers welcome?
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-chevron-down h-5 w-5 text-slate-500 group-open:rotate-180 transition-transform flex-shrink-0"
                >
                  <path d="m6 9 6 6 6-6" />
                </svg>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-slate-600">
                  Absolutely! Our group trips are perfect for solo travelers.
                  You'll meet like-minded people at our pre-trip meetups and
                  make friends before your journey even begins.
                </p>
              </div>
            </details>
            <details className="group bg-white border rounded-xl shadow-sm hover:shadow-md transition-shadow">
              <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                <span className="font-medium text-slate-900 pr-4">
                  What is the cancellation policy?
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-chevron-down h-5 w-5 text-slate-500 group-open:rotate-180 transition-transform flex-shrink-0"
                >
                  <path d="m6 9 6 6 6-6" />
                </svg>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-slate-600">
                  We offer flexible cancellation policies. Full refund if
                  cancelled 30+ days before, 50% refund for 15-30 days, and trip
                  credit for shorter notice periods.
                </p>
              </div>
            </details>
          </div>
        </section>
        <section className="mt-16 bg-gradient-to-r from-teal-600 to-cyan-600 rounded-2xl p-10 text-center">
          <h2 className="text-3xl font-bold text-white mb-3">
            Ready to Explore Spiti Valley?
          </h2>
          <p className="text-white/80 text-lg mb-6 max-w-2xl mx-auto">
            Join thousands of travelers who have discovered amazing experiences
            with Connecting Traveller
          </p>
          <div className="flex gap-4 justify-center">
            <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-11 rounded-md px-8 bg-white text-teal-600 hover:bg-slate-100">
              Browse Group Trips
            </button>
            <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-11 rounded-md px-8 border-white text-white hover:bg-white/10 bg-transparent">
              Plan Custom Trip
            </button>
          </div>
        </section>
      </div>
    </div>

    </>
  );
};

export default DestinationsDetaillist;